import { useFieldHelper, TextField, FieldProps } from 'framework/ui/field';
import { getWithThousandsSeparator } from 'framework/utils';
import React from 'react';
import { StructureItem, BUDGET_STRUCTURE_STATUS } from 'domain/shared/newProject';

interface BudgetAmountFieldProps extends FieldProps {
  showContent: boolean;
}

const BudgetAmountField = ({ source, status, showContent, ...props }: BudgetAmountFieldProps) => {
  const { getValue } = useFieldHelper<StructureItem>({ source });
  const { getValue: getStatus } = useFieldHelper({ source: status });
  const value = getValue();

  if (!showContent) {
    return <>*****</>;
  }

  const { amount = '', currency = '' } = value || {};

  return (
    <TextField
      {...props}
      source={source}
      value={
        getStatus() !== BUDGET_STRUCTURE_STATUS.CLOSED ? `${getWithThousandsSeparator(amount || '')} ${currency}` : '—'
      }
    />
  );
};

export default BudgetAmountField;
